import { Search } from './search';
import { Table } from './table';
import { Form } from './form';

export const Plugins = {
	Search,
	Table,
	Form
};
